/**
 * A small spinning ring, for a wait the student is watching.
 *
 * Screens load with skeletons; this is for the in-place waits that have no
 * layout to sketch — a readiness figure being recomputed, a payment being
 * confirmed — where a blank or a stale number reads as "nothing happened".
 */
export function Spinner({ size = 20, label }: { size?: number; label?: string }) {
  return (
    <span
      role="status"
      aria-label={label ?? "Loading"}
      className="inline-block shrink-0 animate-spin rounded-full border-2 border-border-strong border-t-accent"
      style={{ width: size, height: size }}
    />
  );
}
